import moment from 'moment';
import {colors, drawDashedLine, updateLayersOrder} from '../utils';
import * as _ from 'lodash';
import {drawFigure, getTz} from "../utils";


// tooltip for closed order
export class OrderDetailsContainer extends PIXI.Container {
    constructor(App) {
        super();

        this.zIndex = 7;
        this.App = App;
        this.graphics = new PIXI.Graphics();
        this.addChild(this.graphics);
        this.drawCross();
        this.interactive = true;
        this.visible = false;

        let txt = new PIXI.Text(gettext('The order is closed'));
        txt.style = {fontSize: '16px', fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fontWeight: '500', fill: colors.chart};
        txt.position.set(12, 12);
        this.addChild(txt);

        let price = new PIXI.Text(gettext('price'));
        price.style = {fontSize: '14px', fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fill: colors.chart};
        price.position.set(12, 35);
        this.addChild(price);

        let profit = new PIXI.Text(gettext('profit'));
        profit.style = {fontSize: '14px', fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fill: colors.chart};
        profit.position.set(12, 55);
        this.addChild(profit);

        this.price = price;
        this.profit = profit;
        this.on('mousedown', (event) => {
            event.stopPropagation();
        })
    }

    drawOrder(order) {
        let color = order.profit > 0 ? colors.winner : colors.loser;
        this.graphics.clear();
        this.graphics.beginFill(color, 1).drawRect(0, 0, 170, 85).moveTo(50, 0).lineTo(55, -5).lineTo(60, 0).endFill();
        this.price.text = `by price ${(order.close_price).toFixed(5)/1}`;
        this.profit.text = 'Profit ' + (order.profit > 0 ? (order.profit).toFixed(5)/1 : '0');
        this.hitArea = new PIXI.Rectangle(0, 0, this.width, this.height);
        this.order = order;
    }

    drawCross() {
        let crossGraphics = new PIXI.Graphics();
        let crossContainer = new PIXI.Container();
        this.addChild(crossContainer);
        crossContainer.addChild(crossGraphics);
        crossGraphics.lineStyle(1, colors.chart, 1);
        crossGraphics.moveTo(0, 0).lineTo(10, 10).moveTo(10, 0).lineTo(0, 10);
        crossContainer.position.set(150, 10);
        crossContainer.interactive = true;
        crossContainer.buttonMode = true;
        crossContainer.hitArea = new PIXI.Rectangle(0, 0, crossContainer.width, crossContainer.height);
        crossContainer.on('mousedown', () => {
            this.visible = false;
            this.App.orderDetailsLine.visible = false;
        })
    }

    updatePosition() {
        if (this.visible) {
            let x = this.App.getX(this.order.options_data.expiration_time.unix() * 1000);
            let y = this.App.getY(this.order.close_price) + this.App.chartPosition.top;
            this.position.set(x - 54, y + 20);
        }
    }

    render() {
    }
}


// line near tooltip that shows direction of closed order
export class OrderDetailsLine extends PIXI.Container {
    constructor(App) {
        super();

        this.zIndex = 6;
        this.App = App;
        this.graphics = new PIXI.Graphics();
        this.text = new PIXI.Text(gettext('time'));
        this.text.style = {fontSize: '12px', fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fill: colors.marksTextColor};

        this.addChild(this.graphics, this.text);
        this.visible = false;
    }

    drawOrder(order) {
        let color = order.profit > 0 ? colors.winner : colors.loser;
        this.timestamp = order.options_data.expiration_time.unix() * 1000;


        this.text.text = order.options_data.expiration_time.format('HH:mm.ss');

        this.graphics.clear();
        this.graphics.lineStyle(1, color, 1);
        let height = this.App.renderer.height / this.App.devicePixelRatio;
        this.graphics.moveTo(0, 0).lineTo(0, height);
        this.graphics.lineWidth = 0;
        this.graphics.beginFill(colors.chart, 1).drawCircle(0, 50, 6).endFill();

        this.graphics.lineWidth = 1;
        let delta = order.cmd == 0 ? 2 : -2;
        this.graphics.lineColor = 0x000000;
        this.graphics.moveTo(-3, 50 + delta).lineTo(0, 50 - delta).lineTo(3, 50 + delta);

        let textWidth = this.text.width;

        this.text.position.set(-textWidth / 2, height - (this.text.height + 20) / 2)

        this.graphics.lineWidth = 0;
        drawFigure(this.graphics, [[-textWidth / 2 - 10, height - 20], [-5, height - 20],
                [0, height - 25], [5, height - 20], [textWidth / 2 + 10, height - 20],
                [textWidth / 2 + 10, height],
                [-textWidth / 2 - 10, height], [-textWidth / 2 - 10, height - 20]],
            [color, 1], false);
    }

    updatePosition() {
        this.position.x = this.App.getX(this.timestamp);
    }

    render() {
    }
}


// container for open and recently closed orders at bottom
export class OrderCardsContainer extends PIXI.Container {
    constructor(App) {
        super();
        this.showOrderContainer = new PIXI.Container();
        this.ordersInfoContainer = new PIXI.Container();

        this.addChild(this.showOrderContainer, this.ordersInfoContainer);
        this.zIndex = 8;
        this.App = App;
        this.trades = App.trades;
        this.account = App.account;
        this.quotes = App.quotes;
        // this.position.set(App.renderer.width/App.devicePixelRatio * 0.02, App.renderer.height/App.devicePixelRatio - 90);
        this.position.set(App.renderer.width / App.devicePixelRatio * 0.02);

        this.graphics = new PIXI.Graphics();
        this.graphics.beginFill(0xfab700, 1).drawRect(0, 0, 150, 60).endFill();

        // yellow button
        this.ordersInfoContainer.interactive = true;
        this.ordersInfoContainer.buttonMode = true;
        this.ordersInfoContainer.on('mousedown', () => {
            this.trades.modalOpened = !this.trades.modalOpened;
        });

        this.text = new PIXI.Text(gettext('Show all orders')); 
        this.text.position.set(47, 12);
        this.text.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', lineHeight: 18, fontSize: '16px', fill: 0x000000, wordWrap: true, wordWrapWidth: 85};

        this.icon = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/orders.png');
        this.icon.position.set(16, 14);

        this.ordersInfoContainer.addChild(this.graphics, this.text, this.icon);
    }
    toggleModalHandler() {
        if (this.trades.modalOpened) {
            this.text.destroy();
            this.text = new PIXI.Text(gettext('Close all orders')); 
            this.text.position.set(47, 12);
            this.text.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', lineHeight: 18, fontSize: '16px', fill: 0x000000, wordWrap: true, wordWrapWidth: 85};
            this.ordersInfoContainer.addChild(this.text);
        } else {
            this.text.destroy();
            this.text = new PIXI.Text(gettext('Show all orders')); 
            this.text.position.set(47, 12);
            this.text.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', lineHeight: 18, fontSize: '16px', fill: 0x000000, wordWrap: true, wordWrapWidth: 85};
            this.ordersInfoContainer.addChild(this.text);
        }
    }
    render() {

        if (this.trades.objects) {
            let orders = this.trades.objects.filter((order) => order.options_data && order.options_data.expiration_time.unix() * 1000 > this.App.initTime &&
                (!order.isClosed || Date.now() / 1000 - order.options_data.expiration_time.unix() < 10)
            );

            let compare = (a, b) => {
                if (a.options_data && b.options_data) {
                    return a.options_data.expiration_time.unix() - b.options_data.expiration_time.unix();
                }
                return 0;
            };

            orders.sort(compare);

            let makeAnim = (container, graphics) => {
                if (container.startScale < 1) {
                    container.scale.set(container.startScale, container.startScale);
                    container.startScale += 0.04;
                } else {
                    container.scale.set(1, 1);
                    if (!graphics.borderOut) {
                        if (graphics.borderAlpha < 1) {
                            graphics.borderAlpha = parseFloat((graphics.borderAlpha + 0.02).toFixed(2));
                        } else {
                            graphics.borderOut = true;
                        }
                    };
                    if (graphics.borderOut) {
                        if (graphics.borderAlpha > 0) {
                            graphics.borderAlpha = parseFloat((graphics.borderAlpha - 0.04).toFixed(2));
                        } else {
                            graphics.borderAlpha = 0;
                        }
                    };
                };

                if (container.alpha < 1) {
                    container.alpha += 0.02;
                } else {
                    container.alpha = 1;
                };
            };

            // same logic as for axis marks
            this.showOrderContainer.children.forEach(c => {
                c.visible = false;
            });

            orders.forEach((order, i) => {
                let graphics, container, time, text, circle, volume, arrow;

                let containerIndex = this.showOrderContainer.children.findIndex(container => {
                    return container.order === order.ticket;
                });

                if (containerIndex === -1) {
                    container = new PIXI.Container();

                    container.pivot.y = container.height/2;
                    container.position.y = container.height/2;
                    container.order = order.ticket;
                    this.showOrderContainer.addChildAt(container, i);

                    container.interactive = true;
                    container.buttonMode = true;
                    container.on('click', () => {
                        if (this.quotes.currentQuote.symbol !== order.symbol) {
                            this.quotes.selectSymbol(order.symbol);
                        }
                    });

                    graphics = new PIXI.Graphics();
                    time = new PIXI.Text(gettext('time'));
                    text = new PIXI.Text(gettext('text'));
                    circle = new PIXI.Graphics();
                    volume = new PIXI.Text(gettext('text'));
                    arrow = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/arrow.png');

                    // properties for animation
                    container.startScale = 0.5;
                    container.alpha = 0.2;
                    graphics.borderAlpha = 0;

                    text.style = {
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '18px',
                        fill: colors.marksTextColor,
                        fontWeight: 'bold'
                    };
                    text.text = order.symbol.replace(/_OP$/, '');
                    text.position.y = 12;
                    arrow.anchor.set(0.5, 0.5);
                    arrow.position.y = 22;
                    time.style = {
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '14px',
                        fill: colors.marksTextColor
                    };

                    container.addChild(graphics, time, text, circle, volume, arrow);

                } else {
                    container = this.showOrderContainer.children[containerIndex];
                    this.showOrderContainer.setChildIndex(container, i);
                    graphics = container.children[0];
                    time = container.children[1];
                    text = container.children[2];
                    circle = container.children[3];
                    volume = container.children[4];
                    arrow = container.children[5];
                }

                // position of order
                if (i == 0) {
                    container.position.x = 0;
                } else {
                    let previousContainer = this.showOrderContainer.children[i - 1];
                    container.position.x = previousContainer.position.x + previousContainer.width + 10;
                };

                if ((container.position.x) > (this.App.renderer.width - 430)) {
                    container.visible = false;
                } else {
                   container.visible = true;
                };

                if (order.options_data) {
                    graphics.clear();

                    if (order.isClosed) {
                        circle.visible = false;
                        let symbol = this.account.info.currency.symbol;

                        volume.style = {
                            fontFamily: 'Arial, Helvetica, sans-serif',
                            fontSize: '25px',
                            fill: colors.chart
                        };
                        volume.text = order.profit > 0 ? symbol + String(order.profit) : symbol + '0';
                        volume.position.set(10, (container.height - volume.height) / 2);

                        time.text = gettext('Your income');
                        time.position.set(volume.width + 15, text.position.y + text.height);
                        text.position.x = time.position.x;

                        arrow.rotation = order.cmd == 0 ? 0 : Math.PI;
                        arrow.tint = colors.chart;
                        arrow.position.x = time.position.x + time.width + 10;

                        graphics.beginFill(order.profit > 0 ? colors.winner : 0x575757, 1).drawRect(0, 0, arrow.position.x + arrow.width + 10, 60).endFill();
                    }

                    else {
                        
                        let orderPercent = (Date.now() - moment(order.open_time).unix() * 1000) / (order.options_data.expiration_time.unix() - moment(order.open_time).unix()) / 1000;
                        circle.visible = true;
                        circle.clear().lineStyle(2, order.isWinning ? colors.winner : colors.loser, 1).moveTo(30, 10);
                        circle.arc(30, 30, 20, 1.5 * Math.PI, (Math.PI * (1.5 + 2 * (1 - orderPercent))));

                        let milSec = order.options_data.expiration_time.unix() * 1000 - Date.now();
                        let m = moment.utc(milSec);
                        if (milSec >= 3600000) {
                            time.text = m.format('HH:mm');
                        } else {
                            time.text = milSec < 60000 ? m.format(':ss') : m.format('m') + 'm';
                        }
                        time.position.set(30 - time.width / 2, 30 - time.height / 2);

                        volume.style = {
                            fontFamily: 'Dintext, Arial, Helvetica, sans-serif',
                            fontSize: '14px',
                            fill: colors.marksTextColor
                        };
                        volume.text = this.account.info.currency.symbol + String(order.volume / 100);
                        volume.position.set(62, text.position.y + text.height);

                        text.position.x = 62;

                        arrow.tint = order.isWinning ? colors.winner : colors.loser;
                        arrow.rotation = order.cmd == 0 ? 0 : Math.PI;
                        arrow.position.x = text.width + 72;

                        graphics.beginFill(colors.orderCard, 1).lineStyle(1, 0xfab700, graphics.borderAlpha).drawRect(0, 0, arrow.position.x + arrow.width + 10, 60).endFill();
                        graphics.beginFill(colors.orderCardCircle, 1).lineStyle(0, 0, 1).drawCircle(30, 30, 21).endFill();

                        makeAnim(container, graphics);
                    }
                }
            })
        }

        let tradesDomElem = $('#trades');
        if (tradesDomElem.position().top - 70 < this.App.renderer.height / this.App.devicePixelRatio - 90) {
            this.position.y = tradesDomElem.position().top - 70;
        }
        else {
            this.position.y = this.App.renderer.height / this.App.devicePixelRatio - 90;
        }

        if (this.showOrderContainer.width != 0) {
            this.ordersInfoContainer.position.x = this.showOrderContainer.width + 20;
        }
        else {
            this.ordersInfoContainer.position.x = 0;
        }

        if (this.App.isModalToggle()) {
            this.toggleModalHandler();
        };
    }
}


// open orders marks on line and white dots for closed orders
export class OrderMarksContainer extends PIXI.Container {
    constructor(App) {
        super();
        this.App = App;

        this.zIndex = 2.5;
        this.graphics = new PIXI.Graphics();
        this.texts = new PIXI.Container();
        this.crosses = new PIXI.Container();
        this.graphicsOrderClose = new PIXI.Graphics();
        this.graphicsOrderClose.zIndex = 100;
        this.addChild(this.graphics, this.texts, this.crosses, this.graphicsOrderClose);

        this.circlesBuffer = [];

        this.trades = App.trades;
        this.account = App.account;
        this.quotes = App.quotes;
        this.orderClose = null;
        this.step = 0.05;
        this.start1 = 0.3;
        this.start2 = 0;

        let crossGraphics = new PIXI.Graphics();
        let crossContainer = new PIXI.Container();
        this.graphicsOrderClose.addChild(crossContainer);
        crossContainer.addChild(crossGraphics);
        crossGraphics.lineStyle(1, colors.chart, 1);
        crossGraphics.moveTo(0, 0).lineTo(10, 10).moveTo(10, 0).lineTo(0, 10);
        crossContainer.position.set(230, 10);
        crossContainer.interactive = true;
        crossContainer.buttonMode = true;
        crossContainer.hitArea = new PIXI.Rectangle(0, 0, crossContainer.width, crossContainer.height);
        crossContainer.on('mousedown', () => this.orderClose = null);

        let maskText = new PIXI.Graphics();

        this.graphicsOrderClose.addChild(maskText);

        let textTitle = new PIXI.Text(gettext('Close the order'));
        this.graphicsOrderClose.addChild(textTitle);
        textTitle.style = {fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '16px', fill: colors.chart, align: 'left'};
        textTitle.visible = false;
        textTitle.position.set(10, 10);

        let textYes = new PIXI.Text(gettext('Yes'));
        this.graphicsOrderClose.addChild(textYes);
        textYes.style = {fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '14px', fill: colors.chart, align: 'left'};
        textYes.buttonMode = true;
        textYes.interactive = true;
        textYes.visible = false;
        textYes.position.set(15, textTitle.height + 30);
        textYes.on('mouseover', () => {

            maskText.clear();
            maskText.visible = true;
            maskText.lineStyle(1, colors.chart);
            maskText.drawRect(10, textTitle.height + 25, textYes.width + 10, textYes.height + 10);

        }).on('mouseout', () => {
            maskText.clear();
            maskText.visible = false;
        }).on('mousedown', () => this.closeOrderAction(this.orderClose));


        let textYesSecond = new PIXI.Text(gettext('Yes, and do not ask me'));
        this.graphicsOrderClose.addChild(textYesSecond);
        textYesSecond.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fontSize: '14px', fill: colors.chart, align: 'left'};
        textYesSecond.buttonMode = true;
        textYesSecond.interactive = true;
        textYesSecond.visible = false;
        textYesSecond.position.set(textYes.width + 30, textTitle.height + 30)
        textYesSecond.on('mouseover', () => {

            maskText.clear();
            maskText.visible = true;
            maskText.lineStyle(1, colors.chart);
            maskText.drawRect(textYes.width + 25, textTitle.height + 25, textYesSecond.width + 10, textYesSecond.height + 10);

        }).on('mouseout', () => {
            maskText.clear();
            maskText.visible = false;
        }).on('mousedown', () => {
            localStorage.setItem('donotask', 1);
            this.closeOrderAction(this.orderClose);

        });


        let textNo = new PIXI.Text(gettext('No'));
        this.graphicsOrderClose.addChild(textNo);
        textNo.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fontSize: '14px', fill: colors.chart, align: 'left'};
        textNo.buttonMode = true;
        textNo.interactive = true;
        textNo.visible = false;
        textNo.position.set(textYes.width + textYesSecond.width + 60, textTitle.height + 30)
        textNo.on('mouseover', () => {

            maskText.clear();
            maskText.visible = true;
            maskText.lineStyle(1, colors.chart);
            maskText.drawRect(textYes.width + textYesSecond.width + 55, textTitle.height + 25, textNo.width + 10, textNo.height + 10);

        }).on('mouseout', () => {
            maskText.clear();
            maskText.visible = false;
        }).on('mousedown', () => {
            this.orderClose = null;
        });
        this.circle = new PIXI.Graphics();
        this.textActionClose = new PIXI.Text(gettext('Order is closing'));
        this.textActionClose.style = {fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fontSize: '14px', fill: colors.chart, align: 'left'};
        this.textActionClose.position.set(60, 10);
        this.textActionClose.visible = false;
        this.graphicsOrderClose.addChild(this.circle);
        this.graphicsOrderClose.addChild(this.textActionClose);

    }

    closeOrderAction(order) {

        this.closeAction = true;
        this.trades.closeOrder(order.ticket)
            .then(() => {
                this.closeAction = false;
                this.orderClose = null;
                order.close_time = new Date();
                order.options_data.expiration_time = moment();
            })
            .then(() => {
                return this.trades.reloadTrades();
            })
            .catch(console.error);

    }

    createCircle() {
        let App = this.App;
        let circle = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/circle.png');
        circle.interactive = true;
        circle.buttonMode = true;
        circle.visible = false;

        circle.on('mousedown', (event) => {
            let orders = this.trades.objects.filter((order) => order.symbol == this.quotes.currentSymbol);
            let x = -500, y = -500;

            let order = orders.find((elem, index, arr) => {
                x = App.getX(elem.options_data.expiration_time.unix() * 1000) - this.circlesBuffer[0].width / 2;
                y = App.getY(elem.close_price) + App.chartPosition.top - this.circlesBuffer[0].height / 2;
                return !!(event.target.position.x == x && event.target.position.y == y);
            });

            App.orderDetailsCard.visible = true;
            App.orderDetailsCard.drawOrder(order);
            App.orderDetailsLine.visible = true;
            App.orderDetailsLine.drawOrder(order);
        });

        this.circlesBuffer.push(circle);
        this.addChild(circle);
    }

    drawMark(order, text, cross, x, y) {

        let App = this.App;
        let graphics = this.graphics;


        let milSec = order.options_data.expiration_time.unix() * 1000 - Date.now();
        let fromOpen = (new Date().getTime() - moment(order.open_time).unix() * 1000)

        let m = moment.utc(milSec);

        text.text = milSec >= 3600000 ? m.format('HH:mm') : m.format('m:ss');
        text.visible = true;
        text.position.set(x + 12, y - text.height / 2);

        let plusWidth = 5;
        if (this.account.info.group.options_style == 'american' && fromOpen > 60000) {
            plusWidth = 30;
            cross.visible = true;
            cross.x = x + text.width + 20;
            cross.y = y - 14 / 2;
        } else {
            cross.visible = false;
        }

        if ((_.inRange(App.lastMousePosition.x, x - 16, x + text.width + 16 + plusWidth) && _.inRange(App.lastMousePosition.y, y - 16, y + 16)) || this.orderClose) {
            App.stickToOrder = {
                color: order.isWinning ? colors.winner : colors.loser,
                x: x,
                y: y,
                value: order.open_price,
                moment: moment(order.options_data.expiration_time).tz(getTz().tz),
                openX: App.getX(moment(order.open_time).unix() * 1000),
                openY: App.getY(order.open_price) + App.chartPosition.top
            };
        }
        else {
            drawDashedLine(graphics, x, -7, x, 0.97 * this.parent.height, 5, 2);
        }

        graphics.lineWidth = 0;
        graphics.beginFill(order.isWinning ? colors.winner : colors.loser, 0.8);
        graphics.moveTo(x - 5, y - 16).lineTo(x + 20, y - 16).moveTo(x - 5, y + 16).lineTo(x + text.width + plusWidth, y + 16);
        graphics.arc(x, y, 16, 0.5 * Math.PI, 1.5 * Math.PI).arc(x + text.width + plusWidth, y, 16, -0.5 * Math.PI, 0.5 * Math.PI);
        graphics.endFill();

        graphics.beginFill(colors.chart, 1).drawCircle(x, y, 8).endFill();

        graphics.lineWidth = 1;
        graphics.lineColor = 0x000000;

        let delta = order.cmd == 0 ? 2 : -2;
        graphics.moveTo(x - 3, y + delta).lineTo(x, y - delta).lineTo(x + 3, y + delta);
    }

    closeOrderRender(order) {

        let x = this.App.getX(this.orderClose.options_data.expiration_time.unix() * 1000);
        let y = this.orderClose.isClosed ? this.App.getY(this.orderClose.close_price) + this.App.chartPosition.top : this.App.getY(this.orderClose.open_price) + this.App.chartPosition.top;


        let color = order.isWinning > 0 ? colors.winner : colors.loser;
        this.graphicsOrderClose.visible = true;
        this.graphicsOrderClose.clear();
        this.graphicsOrderClose.beginFill(color, 0.8).drawRect(0, 0, 250, 85).moveTo(50, 0).lineTo(55, -5).lineTo(60, 0).endFill();
        this.graphicsOrderClose.position.set(x - 30, y + 20);

        let renderCircle = () => {
            if (this.start2 > 1) {
                this.start2 = 0;
            }
            this.circle.clear().lineStyle(2, 0xffffff, 1).moveTo(30, 14);
            this.circle.arc(30, 30, 14, 1.5 * Math.PI, (Math.PI * (1.5 + 2 * this.start2)));
            this.circle.endFill();

            this.start2 += this.step;
        }

        let loadeProgress = _.throttle(renderCircle, 1000/60);

        if (this.closeAction) {
            this.graphicsOrderClose.children.forEach((item) => item.visible = false);
            this.circle.visible = true;
            this.textActionClose.visible = true;
            loadeProgress();
        } else {
            this.graphicsOrderClose.children.forEach((item) => item.visible = true);
            this.circle.visible = false;
            this.textActionClose.visible = false;
        }
    }

    filterOrders() {
        let orders = this.trades.objects.filter((order) => {
            return order.symbol == this.quotes.currentSymbol && order.options_data && order.options_data.expiration_time.unix() * 1000 > this.App.initTime;
        });
        return orders;
    };

    render() {
        if (this.trades.objects) {
            let App = this.App;
            let orders = this.filterOrders();

            let graphics = this.graphics;
            let texts = this.texts;
            App.stickToOrder = undefined;

            graphics.clear();
            graphics.lineWidth = 1;
            graphics.lineAlpha = 1;

            for (let i = texts.children.length; i < orders.length; i++) {
                let text = new PIXI.Text(gettext('value'));
                text.style = {
                    fontFamily: 'Dintext, Arial, Helvetica, sans-serif',
                    fontSize: '12px',
                    fill: colors.chart,
                    align: 'center'
                };
                text.visible = false;
                texts.addChild(text);

                let cross = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/cross.png');
                cross.width = cross.height = 14;
                cross.buttonMode = true;
                cross.interactive = true;
                cross.visible = false;
                cross.on('mousedown', (event) => {
                    let orders = this.filterOrders();
                    if (localStorage.getItem('donotask')) {
                        this.closeOrderAction(orders[i]);
                    } else {
                        this.orderClose = orders[i];
                        this.graphicsOrderClose.visible = true;
                    }
                });
                this.crosses.addChild(cross);
            }

            texts.children.forEach((t) => {
                t.visible = false;
            });

            this.crosses.children.forEach((t) => {
                t.visible = false;
            });

            for (let i = this.circlesBuffer.length; i < orders.length; i++) {
                this.createCircle();
            }

            this.circlesBuffer.forEach((circle) => {
                circle.visible = false;
            });

            for (let i = 0; i < orders.length; i++) {
                let order = orders[i];
                let circle = this.circlesBuffer[i];   // TODO: Create circles only for completed orders
                let text = texts.children[i];

                if (order.options_data && _.inRange(order.options_data.expiration_time.unix() * 1000, App.startTimestamp, App.endTimestamp)) {
                    let x = App.getX(order.options_data.expiration_time.unix() * 1000);
                    let y = order.isClosed ? App.getY(order.close_price) + App.chartPosition.top : App.getY(order.open_price) + App.chartPosition.top;

                    if (order.isClosed || order.options_data.expiration_time.unix() * 1000 < Date.now()) {
                        // order.options_data.expiration_time = order.close_time ? moment(order.close_time) : order.options_data.expiration_time;
                        // let x =  order.close_time ? App.getX(moment(order.close_time).unix() * 1000) : x;
                        circle.position.set(x - circle.width / 2, y - circle.height / 2);
                        circle.visible = true;

                        if (!order.drawed) {
                            order.drawed = true;
                            App.orderDetailsCard.visible = true;
                            App.orderDetailsCard.drawOrder(order);
                        }
                    }
                    else {
                        graphics.lineColor = order.isWinning ? colors.winner : colors.loser;
                        this.drawMark(order, text, this.crosses.children[i], x, y);
                    }
                }
            }


            this.graphicsOrderClose.visible = false;
            if (this.orderClose && (this.orderClose.isClosed || (this.orderClose.options_data.expiration_time.unix() * 1000 < Date.now()))) {
                this.orderClose = null;
            }
            this.graphicsOrderClose.children.forEach(item => item.visible = false);
            if (this.orderClose) {
                this.graphicsOrderClose.children.forEach(item => item.visible = true);
                this.closeOrderRender(this.orderClose);
            }

            if (App.stickToOrder && this.zIndex != 5) {
                this.zIndex = 5;
                updateLayersOrder(App.stage);
            }
            if (!App.stickToOrder && this.zIndex != 2.5) {
                this.zIndex = 2.5;
                updateLayersOrder(App.stage);
            }
        }
    }
}